import {DateTime} from 'luxon';
import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  RelativeDateTimeFormatsEnum,
  RelativeDateTimeFormatter,
} from '../../../../../libs/shared/ui/src/components/datetime/relativeDateTimeFormatter';
import {Loader} from '../../../../../libs/shared/ui/src/components/loaders/loader';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {flexCenter} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Styles.
 */

const StyledLastUpdated = styled.div`
  font-size: ${fontSizes.medium};

  color: ${(p) => p.theme.greys.shade60};
  margin-right: 16px;
`;

const StyledProgress = styled(StyledLastUpdated)`
  ${flexCenter}

  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.interactiveText};
`;

const LoaderWrapper = styled.div`
  margin-right: 9px;
  height: fit-content;
`;

/*
 * Helpers.
 */

export function maybeRenderLoader(
  errors: string[],
  progress: number,
  hasStarted: boolean,
  lastUpdated?: DateTime,
) {
  if (errors.length) {
    return null;
  }

  if (progress < 100) {
    return (
      <StyledProgress>
        <LoaderWrapper>
          <Loader size={VisualSizesEnum.MEDIUM} isEnabled />
        </LoaderWrapper>
        {hasStarted ? (
          <Trans id="analytics-header-loader-progress-numeric">
            Progress: {computeJobProgress(progress).toFixed(0)}%
          </Trans>
        ) : (
          <Trans id="analytics-header-loader-progress-request-sent">Fetching report</Trans>
        )}
      </StyledProgress>
    );
  }

  if (lastUpdated) {
    return (
      <StyledLastUpdated>
        <Trans id="analytics-header-last-updated">Last updated</Trans>{' '}
        <RelativeDateTimeFormatter value={lastUpdated.valueOf()} format={RelativeDateTimeFormatsEnum.FULL} />
      </StyledLastUpdated>
    );
  }

  return null;
}

// Show at least 5% progress to the user (Progress will go from 5% to 100%)
function computeJobProgress(progress: number) {
  return 5 + progress * 0.95;
}
